/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Neat_Lean_Panda_HumInputs */

const en_neat_lean_panda_hum = /** @type {(inputs: Neat_Lean_Panda_HumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing…`)
};

const de_neat_lean_panda_hum = /** @type {(inputs: Neat_Lean_Panda_HumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird verarbeitet…`)
};

/**
* | output |
* | --- |
* | "Processing…" |
*
* @param {Neat_Lean_Panda_HumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const neat_lean_panda_hum = /** @type {((inputs?: Neat_Lean_Panda_HumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Neat_Lean_Panda_HumInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_neat_lean_panda_hum(inputs)
	return de_neat_lean_panda_hum(inputs)
});